import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Menu from './components/Menu';
import About from './components/About';
import Catering from './components/Catering';
import ImageGallery from './components/ImageGallery';
import GiftCards from './components/GiftCards';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <Hero />
      <Menu />
      <About />
      <Catering />
      <ImageGallery />
      <GiftCards />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;